import { Component, inject, input, model, output } from "@angular/core";
import { IMainMenuItem } from "./main-menu-item";
import { ConfirmationService, TreeNode } from "primeng/api";
import { toObservable } from "@angular/core/rxjs-interop";
import { filter } from "rxjs";
import { MainMenuService } from "./main-menu.service";
import { TreeHelper } from "./tree-helper";
import { loading } from "@mipro/classes/loading-observable";
import { FormButtonsConfig } from "@mipro/components";
import { DatabaseItemsService } from "./database-items.service";

@Component({
    selector: "select-parent-dialog",
    templateUrl: "./select-parent-dialog.component.html"
})
export class SelectParentDialogComponent {
    private mainMenuService = inject(MainMenuService);
    private databaseItemsService = inject(DatabaseItemsService);
    private confirmationService = inject(ConfirmationService);

    visible = model(false);
    itemId = input(<string>null);
    parentSelected = output<IMainMenuItem>();

    protected selectedNode: TreeNode<IMainMenuItem>;
    protected updatingParent: boolean;
    protected loading$ = toObservable(this.visible).pipe(filter(v => v));
    protected nodes$ = loading(this.loading$, () => this.getAllMenu());
    protected formButtonsConfig = <FormButtonsConfig>{
        saveLabel: "Update",
        saveFunc: () => this.confirmParentUpdate(),
        cancelFunc: () => this.visible.set(false)
    };

    private confirmParentUpdate() {
        if (!this.selectedNode) {
            this.confirmationService.confirm({
                message:
                    "You do not have a menu item selected. Current parent (if any) will be removed <br>" +
                    "Would you like to conitnue with the update?",
                accept: this.updateParent
            });
            return;
        }

        return this.updateParent();
    }

    private async updateParent() {
        this.updatingParent = true;
        try {
            await this.databaseItemsService.updateParent(this.itemId(), this.selectedNode?.data.id);
            this.parentSelected.emit(this.selectedNode?.data);
        } finally {
            this.updatingParent = false;
            this.visible.set(false);
        }
    }

    private async getAllMenu() {
        const menu = await this.mainMenuService.getAll();
        return TreeHelper.createPrimengTree(menu, null);
    }
}
